document.addEventListener('alpine:init', () => {
  Alpine.data('CartFooter', () => {
    return {
      footerRoot: null,
      _morphFooter(e) {
        const inDrawer = Boolean(this.footerRoot.closest('#right-drawer-slot'));
        const sectionKey = inDrawer ? 'cart-footer-drawer' : 'cart-footer';
        let sectionHtml = e.detail.response.sections[sectionKey];
        if (!sectionHtml && inDrawer) {
          sectionHtml = e.detail.response.sections['cart-footer'];
        }

        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          sectionHtml || ''
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              const cls = el.classList;
              if (!cls) return;
              if (cls.contains('additional-checkout-buttons')) {
                skip();
              }
              if (cls.contains('payment-drawer')) {
                skip();
              }
              if (
                el.matches('[data-cart-drawer-summary]') &&
                el.querySelector('[id^="docapp-"], [class*=" docapp-"], [class^="docapp-"]')
              ) {
                skip();
              }
            },
          }
        );
      },
      init() {
        this.footerRoot = this.$root;

        window.addEventListener('baseline:cart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('baseline:cart:cartqtychange', (e) => {
          this._morphFooter(e);
        });
      },
    };
  });
});
